var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 18,
    width: 18,
    height: 3,
    rx: 0.5,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 18V13C18 9.68629 15.3137 7 12 7V7C8.68629 7 6 9.68629 6 13V18",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0996 2.625C11.0996 2.27982 11.3794 2 11.7246 2C12.0698 2 12.3496 2.27982 12.3496 2.625V4.37487C12.3496 4.72001 12.0698 4.99982 11.7247 4.99987C11.3795 4.99993 11.0996 4.72009 11.0996 4.37487V2.625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5371 4.04127C17.7097 3.74233 18.0919 3.63991 18.3909 3.8125C18.6898 3.98509 18.7922 4.36733 18.6196 4.66627L17.7447 6.1817C17.5721 6.4806 17.19 6.58304 16.891 6.41052C16.592 6.23796 16.4896 5.85567 16.6622 5.5567L17.5371 4.04127Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91211 4.04127C5.73952 3.74233 5.35728 3.63991 5.05834 3.8125C4.75941 3.98509 4.65699 4.36733 4.82958 4.66627L5.70451 6.1817C5.87708 6.4806 6.25927 6.58304 6.55819 6.41052C6.85719 6.23796 6.95966 5.85567 6.78705 5.5567L5.91211 4.04127Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b8862e0bfa7ae7540e6b32b85a739d66.svg";
export { ForwardRef as ReactComponent };